import { render, staticRenderFns } from "./BasicInformationDisplayBox.vue?vue&type=template&id=e4b4ffbe&"
import script from "./BasicInformationDisplayBox.vue?vue&type=script&lang=js&"
export * from "./BasicInformationDisplayBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports